import { inject } from 'vue';

export function updateTestAssortmentMenu(page: any) {
  const setSessionValue = inject('setTestAssortmentHomeSessionValue') as ((val: string) => void) | undefined;

  if (typeof window !== 'undefined' && window.sessionStorage) {
    const giftCardCategory = page?.dataJson?.dataJson?.giftCardCategory;
    const isTestAssortment = page?.dataJson?.dataJson?.category?.isTestAssortment;

    const url = page?.dataJson?.dataJson?.category?.url;
    if (!giftCardCategory && (page?.type === 'Category' || page?.type === 'Product') && isTestAssortment && url) {
      setSessionValue?.(url);
    }
  }
}

export function removeTestAssortmentHomeUrl() {
  const setSessionValue = inject('setTestAssortmentHomeSessionValue') as ((val: string) => void) | undefined;
  setSessionValue?.('');
}

export function useTestAssortmentMenu(activeGiftCard: any, url: string | undefined) {
  const hasAnyActiveGiftCards = activeGiftCard?.giftCards?.length > 0;
  return !hasAnyActiveGiftCards && typeof url !== 'undefined' && url !== null && url !== '';
}
